import { IRoleIsSystemLang } from '../../../types/lang'
import { ERoleIsSystem } from '../../../types'

export const roleIsSystemLang: IRoleIsSystemLang = {
	role_is_system: {
		[ERoleIsSystem.System]: 'System_ua',
		[ERoleIsSystem.NotSystem]: 'Not System_ua',
	}
}